/* Size chart popup (snippets/size-chart.liquid) */
if (!customElements.get("size-chart")) {
  class SizeChart extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector(".size-chart__link");
      this.modal = this.querySelector(".size-chart__modal");
      if (!this.trigger || !this.modal || typeof this.modal.showModal !== "function") return;

      this.onTriggerClick = this.open.bind(this);
      this.onModalClick = this.handleModalClick.bind(this);
      this.onCancel = (event) => {
        event.preventDefault();
        this.close();
      };

      this.trigger.addEventListener("click", this.onTriggerClick);
      this.modal.addEventListener("click", this.onModalClick);
      this.modal.addEventListener("cancel", this.onCancel);

      // Set products: "Top" / "Bottom" tabs
      this.tabs = Array.from(this.modal.querySelectorAll("[data-size-chart-tab]"));
      if (this.tabs.length) {
        this.onTabKeydown = this.handleTabKeydown.bind(this);
        this.modal.addEventListener("keydown", this.onTabKeydown);
      }
    }

    disconnectedCallback() {
      if (!this.modal) return;
      this.trigger.removeEventListener("click", this.onTriggerClick);
      this.modal.removeEventListener("click", this.onModalClick);
      this.modal.removeEventListener("cancel", this.onCancel);
      if (this.onTabKeydown) this.modal.removeEventListener("keydown", this.onTabKeydown);
      document.documentElement.classList.remove("size-chart-open");
    }

    open() {
      if (this.modal.open) return;
      clearTimeout(this.closeTimer);
      document.documentElement.classList.add("size-chart-open");
      this.modal.showModal();
      this.modal.scrollTop = 0;
      const closeButton = this.modal.querySelector("[data-size-chart-close]");
      if (closeButton) closeButton.focus({ preventScroll: true });
      requestAnimationFrame(() => this.modal.classList.add("is-open"));
    }

    close() {
      if (!this.modal.open || this.closing) return;
      this.closing = true;
      this.modal.classList.remove("is-open");
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      this.closeTimer = setTimeout(() => {
        this.modal.close();
        this.closing = false;
        document.documentElement.classList.remove("size-chart-open");
        this.trigger.focus({ preventScroll: true });
      }, reduceMotion ? 0 : 200);
    }

    handleModalClick(event) {
      // Clicks on the dialog element itself land on the ::backdrop (overlay).
      if (event.target === this.modal || event.target.closest("[data-size-chart-close]")) {
        this.close();
        return;
      }
      const tab = event.target.closest("[data-size-chart-tab]");
      if (tab) this.selectTab(tab);
    }

    handleTabKeydown(event) {
      const index = this.tabs.indexOf(event.target);
      if (index === -1) return;
      const last = this.tabs.length - 1;
      const keys = {
        ArrowRight: index === last ? 0 : index + 1,
        ArrowLeft: index === 0 ? last : index - 1,
        Home: 0,
        End: last,
      };
      if (!(event.key in keys)) return;
      event.preventDefault();
      const next = this.tabs[keys[event.key]];
      this.selectTab(next);
      next.focus();
    }

    selectTab(selected) {
      this.tabs.forEach((tab) => {
        const isSelected = tab === selected;
        tab.setAttribute("aria-selected", isSelected ? "true" : "false");
        tab.tabIndex = isSelected ? 0 : -1;
        const panel = this.modal.querySelector(`#${tab.getAttribute("aria-controls")}`);
        if (panel) panel.hidden = !isSelected;
      });
    }
  }

  customElements.define("size-chart", SizeChart);
}
